<template >
  <div class="">
    <template v-for="(item, index) in subMenuList">
      <el-submenu
        v-if="item.children && item.children.length > 0 && !item.hidden"
        :key="index + 'el-submenu'"
        :index="resolvePath(item.path)"
      >
        <template slot="title">
          <i :class="item.meta.icon && item.meta.icon"></i>
          <span>{{ item.meta.title }}</span>
        </template>

        <SubMenu
          :subMenuList="item.children"
          :base-path="resolvePath(item.path)"
        />
      </el-submenu>
      <el-menu-item
        v-if="!item.children && !item.hidden"
        :key="index + item.path"
        :index="resolvePath(item.path)"
        @click="click(item)"
      >
        <i :class="item.meta.icon && item.meta.icon"></i>
        <span slot="title">{{ item.meta.title }}</span>
      </el-menu-item>
    </template>
  </div>
</template>
         
<script>
import path from "path";
import SubMenu from "./subMenu";
export default {
  name: "SubMenu", //必须要 递归组件的关键，并且要与引入组件的变量名称一致
  components: {
    SubMenu,
  },
  props: {
    subMenuList: {
      type: Array,
      default: [],
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    click(item) {
      if (item.meta.isExternal) {
        this.$router.go(-1);
        // window.location.href = item.meta.path;
        window.open(item.meta.path);
      }
    },
    resolvePath(routePath) {
      return path.resolve(this.basePath, routePath);
    },
  },
};
</script>
<style lang='scss' scoped>
.el-menu-item.is-active {
  background-color: #0d6eb3;
}
</style>
